import React from 'react';
import Header from '../../../components/header';
import SingleBlogBody from './body';
import Footer from '../../../components/footer';

function SingleBlog(props) {
    return (
        <div>
            <Header></Header>
            <SingleBlogBody></SingleBlogBody>
            <Footer></Footer>
        </div>
    );
}

export default SingleBlog;